export const enecoMessagebarColors = {
  messagebarBackground: '{{ secondaryColors.purple900 }}',
  messagebarHoverBackground: '#2a183b',
  messagebarText: '{{ textColors.textInverted }}',
};
